import React from 'react'

interface DataTableColumn {
  title: string
  onClick?: (data: string | number) => void
}

export enum SortOrder {
  ASC = 1,
  DESC = -1,
}

interface Props {
  heading: string | React.ReactNode
  columns: DataTableColumn[]
  data: (string | number)[][]
  showId?: boolean
  defaultSort?: { sortColumnIndex?: number; sortOrder?: SortOrder }
  keyIndex?: number
}

interface State {
  sortColumnIndex: number
  sortOrder: number
}

export class DataTable extends React.Component<Props, State> {
  state: State = {
    sortColumnIndex: (this.props.defaultSort && this.props.defaultSort.sortColumnIndex) || 0,
    sortOrder: (this.props.defaultSort && this.props.defaultSort.sortOrder) || 1,
  }

  render() {
    const { heading, columns, data, showId, keyIndex } = this.props
    const tableHead = (headingColumns: DataTableColumn[]) => (
      <thead>
        <tr>
          {headingColumns.map((headingColumn, index) => (
            <th
              key={headingColumn.title}
              className="clickable"
              onClick={() => {
                this.orderByColumn(showId ? index : index + 1)
              }}
            >
              {`${headingColumn.title} `}
              <span
                className={`${
                  this.state.sortColumnIndex === (showId ? index : index + 1) ? '' : 'invisible'
                } glyphicon glyphicon-chevron-${this.state.sortOrder === 1 ? 'up' : 'down'}`}
              />
            </th>
          ))}
        </tr>
      </thead>
    )

    const tableBodyRow = (records: (string | number)[], rowIndex: number) => (
      <tr key={records[keyIndex || 0] || rowIndex}>
        {records
          .filter((record, columnIndex) => columnIndex !== 0 || showId)
          .map((record, columnIndex) => {
            const props = columns[columnIndex].onClick && {
              className: 'clickable',
              onClick: () => columns[columnIndex].onClick!(record),
            }
            return (
              <td key={`${records[0] || rowIndex}-${columnIndex}`} {...props}>
                {record}
              </td>
            )
          })}
      </tr>
    )

    const tableBody = (records: (string | number)[][]) => <tbody>{records.map(tableBodyRow)}</tbody>

    data.sort((a, b) => {
      if (a[this.state.sortColumnIndex] > b[this.state.sortColumnIndex]) {
        return this.state.sortOrder
      }

      if (a[this.state.sortColumnIndex] < b[this.state.sortColumnIndex]) {
        return -this.state.sortOrder
      }

      return 0
    })

    return (
      <div className="panel reference-box result-heading">
        <div className="panel-heading">{heading}</div>
        <div className="panel-body">
          <div className="table-responsive">
            <table className="table">
              {tableHead(columns)}
              {tableBody(data)}
            </table>
          </div>
        </div>
      </div>
    )
  }

  private orderByColumn = (sortColumnIndex: number) => {
    if (this.state.sortColumnIndex === sortColumnIndex) {
      this.setState(state => ({ sortOrder: state.sortOrder * -1 }))
    } else {
      this.setState({ sortColumnIndex, sortOrder: 1 })
    }
  }
}
